const E = {
  1: 'Navigate page listings by selecting a page number or going back or forth one page at a time using Back and Next. Jump to first and last page using First and Last.',
};

const F = {
  1: 'Naviguez dans les listes de pages en sélectionnant un numéro de page ou en parcourant les pages l\'une après l\'autre à l\'aide des boutons Précédent et Suivant. Aller à la première et la dernière page en utilisant First et Last.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/tutorials/pagination.js